@if (visible()) {
  <div
    #dialog
    class="onboarding-modal"
    [class.dark]="isDark"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-title"
  >
    <div class="modal-content">
      <button class="close-button" (click)="cancel()" aria-label="Schließen">
        <span class="close-icon" aria-hidden="true"></span>
      </button>

      <div class="text-col">
        <div class="scroll-area">
          <div class="progress">
            <div class="progress-fill" [style.width.%]="progressPercent()"></div>
          </div>

          <img class="logo" [src]="logo" alt="finanzen.net" />

          <h2 class="title" id="onboarding-title">{{ steps[step()].title }}</h2>
          @if (steps[step()].subtitle) {
            <p class="subtitle">{{ steps[step()].subtitle }}</p>
          }
          <p class="description" [class.legal]="isLastStep()">{{ steps[step()].description }}</p>

          @if (isLastStep()) {
            <p class="terms">
              Mit dem Fortfahren nimmst Du die
              <a routerLink="/privacy" queryParamsHandling="preserve">Datenschutzbestimmungen</a>
              zur Kenntnis und akzeptierst die
              <a routerLink="/terms" queryParamsHandling="preserve">Nutzungsbedingungen</a> der
              finanzen.net GmbH.
            </p>
          }
        </div>

        <div class="buttons">
          <button class="next-button" (click)="next()">
            {{ isLastStep() ? 'Verstanden und fortfahren' : 'Weiter' }}
          </button>
          <button class="cancel-button" (click)="cancel()">Abbrechen</button>
        </div>
      </div>

      <!-- Keyed by step so the element is recreated and the mount animation replays. -->
      @for (s of [step()]; track s) {
        <img class="visual" [src]="stepImage" alt="" (load)="visualLoaded($event)" />
      }
    </div>
  </div>
}
